import React from "react";

export default function TenantHeader({ branding }) {
  if (!branding) return null;

  // Si le backend renvoie du HTML complet, on l'utilise
  if (branding.headerHtml) {
    return (
      <>
        <div dangerouslySetInnerHTML={{ __html: branding.headerHtml }} />
        {branding.serviceTitle && (
          <h2 className="title-rapport">{branding.serviceTitle}</h2>
        )}
      </>
    );
  }

  // 🆕 Nouveau : si on veut injecter un code libre (HTML + CSS)
  if (branding.freeHtml) {
    return (
      <>
        <div dangerouslySetInnerHTML={{ __html: branding.freeHtml }} />
        {branding.serviceTitle && (
          <h2 className="title-rapport">{branding.serviceTitle}</h2>
        )}
      </>
    );
  }

  const { leftLines = [], rightLines = [], logoUrl, serviceTitle } = branding;
  const hasRightContent = (rightLines && rightLines.length > 0) || logoUrl;

  return (
    <>
      <div className={`header ${!hasRightContent ? "single-column" : ""}`}>
        {/* LEFT */}
        <div className="left">
          {leftLines.map((line, i) => {
            if (line.startsWith("##grand##")) {
              return (
                <p key={i} className="grand-header">
                  {line.replace("##grand##", "")}
                </p>
              );
            } else if (line.startsWith("<")) {
              return (
                <div key={i} dangerouslySetInnerHTML={{ __html: line }} />
              );
            } else {
              return <p key={i}>{line}</p>;
            }
          })}
        </div>

        {/* RIGHT (uniquement si contenu présent) */}
        {hasRightContent && (
          <div className="right">
            {rightLines.map((line, i) => {
              if (line.startsWith("##grand##")) {
                return (
                  <p key={i} className="grand-header">
                    {line.replace("##grand##", "")}
                  </p>
                );
              } else if (line.startsWith("<")) {
                return (
                  <div key={i} dangerouslySetInnerHTML={{ __html: line }} />
                );
              } else {
                return <p key={i}>{line}</p>;
              }
            })}
            {logoUrl && (
              <img src={logoUrl} alt="Logo" className="logo-clinique" />
            )}
          </div>
        )}
      </div>

      {serviceTitle && <h2 className="title">{serviceTitle}</h2>}
    </>
  );
}
